/* eslint-disable react/function-component-definition */
import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/fontawesome-free-solid";
import { Entry } from "../../redux/entrySlice";
import styles from "./createCafePopup.module.scss";
import { TableContext } from "../../contexts/tableContext";
import MultipleFileUpload from "../../components/MultipleFileUpload/MultipleFileUpload";
import "react-toastify/dist/ReactToastify.css";
import TextInput from "../../components/TextField/TextField";
import EmailInput from "../../components/EmailBox/EmailBox";
import {
  REACT_APP_API_ROLES_DROPDOWN,
  REACT_APP_API_VENDORS_LIST,
  SERVER_URL,
} from "../../redux/apiConstants";
import { useNavigate } from "react-router-dom";
import { Row, Col, Container } from "react-bootstrap";
import axios from "axios";
import LocationSelectBox from "../../components/LocationSelectBox/LocationSelectBox";
import TimePickerComponent from "../../components/TimePicker/TimePicker";
import MapPinPickerModal from "../../components/MapPinPickerModal/MapPinPickerModal";

const CreateCafePopup = React.memo(
  ({ setTableData, handleClose, setIsUpdated }) => {
    const { dashboardStyle } = useContext(TableContext);
    const [submiting, setSubmitting] = useState(false);
    const { bodyStyle } = useContext(TableContext);
    const { formthemeStyle } = useContext(TableContext);
    const { setDashboardHeader } = useContext(TableContext);
    const { errormsgStyle } = useContext(TableContext);
    const { dashUpdate, setDashUpdate } = useContext(TableContext);
    const [roles, setRoles] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [zipCodes, setZipCodes] = useState([]);
    const [text, setText] = useState();
    const [locations, setLocations] = useState([]);
    const [timeInvalid, setTimeInvalid] = useState(false);
    const [manualCoordinates, setManualCoordinates] = useState(null);
    const [showMapModal, setShowMapModal] = useState(false);
    const [selectedLocationData, setSelectedLocationData] = useState(null);

    const navigate = useNavigate();
    const [error, setError] = useState(null);
    const [perror, setPerror] = useState(null);

    const [timings, setTimings] = useState([
      { dayOfWeek: "Monday", periods: [] },
      { dayOfWeek: "Tuesday", periods: [] },
      { dayOfWeek: "Wednesday", periods: [] },
      { dayOfWeek: "Thursday", periods: [] },
      { dayOfWeek: "Friday", periods: [] },
      { dayOfWeek: "Saturday", periods: [] },
      { dayOfWeek: "Sunday", periods: [] },
    ]);

    // Helper function to generate unique ID for periods
    const generatePeriodId = () => `period_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

    const parseTime24 = (time) => {
      if (!time) return null;
      const [hours, minutes, seconds] = time.split(":").map(Number);
      return hours * 3600 + minutes * 60 + (seconds || 0);
    };

    const handleTimingsChange = (dayIndex, periodIndex, type, value) => {
      setTimings((prevTimings) => {
        const updatedTimings = [...prevTimings];
        const period = updatedTimings[dayIndex].periods[periodIndex];
        
        if (type === "startLocalTime") {
          period.startLocalTime = value || "";
        } else if (type === "endLocalTime") {
          period.endLocalTime = value || "";
        }

        // Validation
        if (period.startLocalTime && period.endLocalTime) {
          const startSeconds = parseTime24(period.startLocalTime);
          const endSeconds = parseTime24(period.endLocalTime);
          
          if (startSeconds === endSeconds) {
            toast.error("Start time and End time cannot be the same.");
            period[type] = "";
            setTimeInvalid(true);
            return updatedTimings;
          }

          // Check if end time is before start time (indicates next day)
          if (endSeconds < startSeconds) {
            period.isNextDay = true;
          } else {
            period.isNextDay = false;
          }
        }

        // Check if any period has incomplete times
        const hasInvalidPeriod = updatedTimings.some(timing =>
          timing.periods.some(p => 
            (p.startLocalTime && !p.endLocalTime) || 
            (!p.startLocalTime && p.endLocalTime)
          )
        );
        setTimeInvalid(hasInvalidPeriod);

        return updatedTimings;
      });
      return true;
    };

    const handleAddPeriod = (dayIndex) => {
      setTimings((prevTimings) => {
        const currentPeriods = prevTimings[dayIndex].periods;
        
        // Only validate if there are existing periods
        if (currentPeriods && currentPeriods.length > 0) {
          const hasInvalidPeriod = currentPeriods.some(p => 
            !p.startLocalTime || !p.endLocalTime
          );
          
          if (hasInvalidPeriod) {
            toast.error("Please complete the current period before adding a new one.");
            return prevTimings; // Don't add new period
          }
        }
        
        // Add new period with unique ID
        const updatedTimings = [...prevTimings];
        updatedTimings[dayIndex] = {
          ...updatedTimings[dayIndex],
          periods: [...updatedTimings[dayIndex].periods, {
            id: generatePeriodId(),
            startLocalTime: "",
            endLocalTime: "",
            isNextDay: false
          }]
        };
        return updatedTimings;
      });
    };

    const handleRemovePeriod = (dayIndex, periodId) => {
      setTimings((prevTimings) => {
        const updatedTimings = [...prevTimings];
        updatedTimings[dayIndex].periods = updatedTimings[dayIndex].periods.filter(
          period => period.id !== periodId
        );
        return updatedTimings;
      });
    };

    const getVendors = async () => {
      const vendorsList = await axios.get(REACT_APP_API_VENDORS_LIST);
      console.log("vendor list---", vendorsList.data?.data?.result);
      // const transformedVendors = vendorsList.data?.data?.result?.results?.map(
      //   (vendor) => ({
      //     value: vendor.id,
      //     label: vendor.name,
      //   })
      // );
      setVendors(vendorsList.data?.data?.result);
    };

    // const getZipCodes = async () => {
    //   const zipCodeList = await axios.get(REACT_APP_API_FETCH_ZIPCODES);
    //   console.log("zip code list", zipCodeList.data?.data?.result);
    //   const transformedZipCodes = zipCodeList.data?.data?.result?.map(
    //     (zipcode) => ({
    //       value: zipcode.zipCode,
    //       label: zipcode.zipCode,
    //     })
    //   );
    //   console.log(transformedZipCodes, "transformed zipcodes");
    //   setZipCodes(transformedZipCodes);
    // };

    const getLocation = async () => {
      try {
        const response = await axios.get(
          `${SERVER_URL}/location?location=${text}`
        );
        console.log("location-----", response.data);
        setLocations(response.data.data);
      } catch (error) {
        console.log("erroorrr--", error);
        console.error("Error fetching location:", error);
      }
    };
    useEffect(() => {
      getLocation();
    }, [text]);
    console.log(text, "text");

    useEffect(() => {
      window.scrollTo(0, 0);
      // setDashboardHeader("Add Cafe Details");
      const url = REACT_APP_API_ROLES_DROPDOWN; // api url
      fetch(url)
        .then((resp) => resp.json()) // calling url by method GET
        .then((resp) => setRoles(resp.data.role.selectdata)); // setting response to state roles
      getVendors();
      getLocation();
      // getZipCodes();
    }, []);
    const dispatch = useDispatch();
    const { files } = useContext(TableContext);

    const {
      control,
      register,
      handleSubmit,
      reset,
      watch,
      setValue,
      formState: { errors },
    } = useForm();

    const watchLocationName = watch("location_name");
    function onSubmitdata(data) {
      console.log("dataa--", data);

      setSubmitting(true);
      setError(null);

      // Validate that we have location data (either manual or autocomplete)
      if (!manualCoordinates && !data.location_name?.location) {
        toast.error("Please select a location using autocomplete or pick on map");
        setSubmitting(false);
        return;
      }

      // Use manual coordinates if set, otherwise use autocomplete coordinates
      const finalLocation = manualCoordinates || data.location_name.location;
      const finalAddress = data.location_name?.formatted_address || selectedLocationData?.formatted_address || "";

      // Clean timings - remove the 'id' field before sending to API
      const cleanedTimings = timings.map(timing => ({
        dayOfWeek: timing.dayOfWeek,
        periods: timing.periods.map(period => ({
          startLocalTime: period.startLocalTime,
          endLocalTime: period.endLocalTime,
          isNextDay: period.isNextDay
        }))
      }));

      // Format timings into an array
      const apiData = {
        name: data.name,
        description: data.description ?? "",
        // timings: JSON.stringify(timings),
        address: data.address,
        businessAddress: data.businessAddress,
        locationTitle: data.locationTitle,
        location_name: finalAddress,
        location: JSON.stringify(finalLocation),
        facebook: data.facebook ?? "",
        instagram: data.instagram ?? "",
        email: data.email ?? "",
        ccProcessingConfig: {
          percentage: data?.ccProcessingConfig?.percentage || "2.9",
          fixedFee: data?.ccProcessingConfig?.fixedFee || "0.3",
        },
        // vendor: data.Vendor,
        // zipCode: data.zipCode,
        File: files,
        timings: JSON.stringify(cleanedTimings),
      };
      console.log("api data", apiData);
      data.actionUrl = "cafe";
      data.actionMethod = "post";
      data.apiData = apiData;
      dispatch(Entry(data)).then((resp) => {
        setSubmitting(false);
        if (resp.payload.code === 200) {
          console.log(resp.payload.data.result);
          toast.success("Cafe Creation Successful");
          handleClose();
          setIsUpdated(true);
          if (!dashUpdate) {
            setDashUpdate(true);
          }
          setTableData((prevData) => [...prevData, ...apiData]);
          toast.success("Cafe added successfully.");
        } else if (resp.payload.code === 401 || resp.payload.code === 400) {
          setError(resp.payload.message);
          
          toast.error(
            "Cafe creation failed due to the error:",
            resp.payload.message
          );
        } else {
          setError(resp?.payload?.message);
        }
      });
    }

    const handleLocationChange = async (value) => {
      setText(value);
    };

    const handleOpenMapModal = () => {
      // Allow opening map even without autocomplete selection
      setShowMapModal(true);
    };

    const handleMapConfirm = (data) => {
      setManualCoordinates(data.coordinates);
      setSelectedLocationData({
        location: data.coordinates,
        formatted_address: data.address,
      });
      
      // Update the form value directly - this will show in the autocomplete field
      const locationData = {
        location: data.coordinates,
        formatted_address: data.address,
      };
      
      // Use setValue instead of reset to update just the location field
      setValue("location_name", locationData);
      
      setShowMapModal(false);
      toast.success("Location set from map!");
    };

    const handleResetManualPin = () => {
      setManualCoordinates(null);
      setSelectedLocationData(null);
      setValue("location_name", null);
      toast.info("Location cleared - please select again");
    };

    return (
      <div className={styles.popupbox}>
        <div className={styles.box} id={styles.box}>
          <button
            className={styles.closeicon}
            aria-label="Close"
            onClick={handleClose}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
          <h2 className={styles.heading}>Create Cafe</h2>
          <div className="container-fluid mt-5">
            <form onSubmit={handleSubmit(onSubmitdata)}>
              <div className="row">
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <TextInput
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    labelstyle={styles.formlabel}
                    label="Name"
                    fieldName="name"
                    placeHolder="Enter Name"
                    register={register}
                    errors={errors}
                    isRequired
                    mandatory
                  />
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <label htmlFor="description" className={styles.formlabel}>
                    Description
                  </label>
                  <textarea
                    id="description"
                    className={`${styles.inputbox}`}
                    placeholder="Enter Description"
                    {...register("description")}
                    rows={1}
                    style={{ resize: "none", overflowY: "auto" }}
                    onInput={(e) => {
                      e.target.style.height = "auto";
                      e.target.style.height = `${Math.min(
                        e.target.scrollHeight,
                        80
                      )}px`;
                    }}
                  />
                </div>
              </div>

              <div className="row">
                {/* <div className="col-lg-6 col-md-12 col-sm-12">
                  <TimePickerComponent
                    control={control}
                    name="startTime"
                    isRequired={true}
                    errors={errors}
                    label="Start Time"
                    className="custom-timepicker"
                    mandatory
                  />
                  <TimePickerComponent
                    control={control}
                    name="endTime"
                    isRequired={true}
                    errors={errors}
                    label="End Time"
                    className="custom-timepicker"
                    mandatory
                  />
                </div> */}

                {/* {daysOfWeek.map((day) => (
                  <div className="col-lg-6 col-md-12 col-sm-12" key={day}>
                    <div className="form-group">
                      <label>{`${day} Start Time`}</label>
                      <TimePickerComponent
                        {...register(`${day.toLowerCase()}StartTime`, {
                          required: true,
                        })}
                        label={`${day} Start Time`}
                        errors={errors}
                        className="custom-timepicker"
                        // isRequired
                        control={control}
                      />
                      {errors[`${day.toLowerCase()}StartTime`] && (
                        <span>This field is required</span>
                      )}
                    </div>
                    <div className="form-group">
                      <label>{`${day} End Time`}</label>
                      <TimePickerComponent
                        {...register(`${day.toLowerCase()}EndTime`, {
                          required: true,
                        })}
                        label={`${day} End Time`}
                        errors={errors}
                        className="custom-timepicker"
                        // isRequired
                        control={control}
                      />
                      {errors[`${day.toLowerCase()}EndTime`] && (
                        <span>This field is required</span>
                      )}
                    </div>
                  </div>
                ))} */}

                {/* <div className="col-lg-6 col-md-12 col-sm-12">
                  <SelectBox
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    name="Vendor"
                    label="Vendor"
                    labelstyle={styles.formlabel}
                    control={control}
                    register={register}
                    values={vendors}
                    errors={errors}
                    placeholder="Choose Vendor"
                    mandatory
                    isRequired
                  />
                </div> */}

                <div className="col-lg-6 col-md-12 col-sm-12">
                  <div style={{ position: "relative" }}>
                    <LocationSelectBox
                      className={styles.inputbox}
                      classNamedark={styles.inputbox1}
                      name="location_name"
                      label="Location (For GPS) - Search or Pick on Map"
                      labelstyle={styles.formlabel}
                      control={control}
                      register={register}
                      values={locations}
                      errors={errors}
                      placeholder="Search location or use map below"
                      mandatory={false}
                      isRequired={false}
                      setText
                      handleLocationChange={handleLocationChange}
                      onLocationSelect={(locationData) => {
                        console.log(
                          "Location selected with coordinates:",
                          locationData
                        );
                        setSelectedLocationData(locationData);
                        setManualCoordinates(null); // Reset manual pin when using autocomplete
                      }}
                    />
                    <button
                      type="button"
                      onClick={handleOpenMapModal}
                      style={{
                        marginTop: "8px",
                        padding: "8px 16px",
                        backgroundColor: "#39979d",
                        color: "white",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "600",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        transition: "all 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#2d7b80";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "#39979d";
                      }}
                    >
                      📍 {manualCoordinates || watchLocationName?.location ? "Adjust Pin" : "Pick Location on Map"}
                    </button>
                    {(manualCoordinates || watchLocationName?.location) && (
                      <div
                        style={{
                          marginTop: "10px",
                          padding: "12px",
                          backgroundColor: "#e8f5e9",
                          borderRadius: "6px",
                          border: "1px solid #81c784",
                          fontSize: "13px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "8px",
                          }}
                        >
                          <strong style={{ color: "#2e7d32" }}>
                            ✓ Location Selected
                          </strong>
                          {manualCoordinates && (
                            <button
                              type="button"
                              onClick={handleResetManualPin}
                              style={{
                                padding: "4px 10px",
                                fontSize: "12px",
                                backgroundColor: "#fff",
                                color: "#d32f2f",
                                border: "1px solid #d32f2f",
                                borderRadius: "4px",
                                cursor: "pointer",
                                fontWeight: "500",
                              }}
                            >
                              Clear
                            </button>
                          )}
                        </div>
                        <div style={{ color: "#424242", fontSize: "14px", lineHeight: "1.5" }}>
                          {selectedLocationData?.formatted_address || watchLocationName?.formatted_address || "Location coordinates set"}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12">
                  {" "}
                  <TextInput
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    labelstyle={styles.formlabel}
                    label="Instagram"
                    placeHolder="Instagram"
                    fieldName="instagram"
                    register={register}
                    errors={errors}
                    // isRequired
                    // mandatory
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <EmailInput
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    labelstyle={styles.formlabel}
                    label="Email"
                    placeHolder="enter email address"
                    fieldName="email"
                    register={register}
                    errors={errors}
                    isRequired={false}
                    mandatory={false}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <TextInput
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    labelstyle={styles.formlabel}
                    label="Address"
                    placeHolder="Enter Address"
                    fieldName="address"
                    register={register}
                    errors={errors}
                    isRequired
                    maximLengt="200"
                    mandatory
                  />
                  {/* <NumberInput
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    labelstyle={styles.formlabel}
                    label="Zip Code"
                    placeHolder="Enter Zip Code"
                    fieldName="zipCode"
                    register={register}
                    errors={errors}
                    isRequired
                    mandatory
                    minimLength={5}
                    maximLength={5} /> */}

                  {/* <SelectBox
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    name="zipCode"
                    label="Zip Code"
                    labelstyle={styles.formlabel}
                    control={control}
                    register={register}
                    values={zipCodes}
                    errors={errors}
                    placeholder="Choose ZipCode"
                    mandatory
                    isRequired
                  /> */}
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <TextInput
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    labelstyle={styles.formlabel}
                    label="Facebook"
                    placeHolder="Facebook"
                    fieldName="facebook"
                    register={register}
                    errors={errors}
                    // isRequired
                    // mandatory
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <TextInput
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    labelstyle={styles.formlabel}
                    label="Business Address"
                    placeHolder="Enter Business Address"
                    fieldName="businessAddress"
                    register={register}
                    errors={errors}
                    maximLengt="200"
                  />
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <TextInput
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    labelstyle={styles.formlabel}
                    label="Location Title"
                    placeHolder="Enter location title (e.g. Downtown Seattle)"
                    fieldName="locationTitle"
                    register={register}
                    errors={errors}
                    // isRequired
                    // mandatory
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-3 col-sm-3">
                  <TextInput
                    className={styles.inputbox}
                    label="Credit Card Fee Percentage (%)"
                    fieldName="ccProcessingConfig.percentage"
                    placeHolder="e.g. 2.9"
                    register={register}
                    errors={errors}
                    // isRequired
                    // mandatory
                  />
                </div>
                <div className="col-md-3 col-sm-3">
                  <TextInput
                    className={styles.inputbox}
                    label="Credit Card Fixed Fee ($)"
                    fieldName="ccProcessingConfig.fixedFee"
                    placeHolder="e.g. 0.3"
                    register={register}
                    errors={errors}
                    // isRequired
                    // mandatory
                  />
                </div>
              </div>
              {/* cafe hours */}
              <div className="row">
                <Col lg={8} md={12} sm={12}>
                  {/* Cafe Hours */}
                  <h6 className={styles.heading}>Cafe Hours (24-hour format)</h6>
                  {timings.map((timing, dayIndex) => (
                    <div key={timing.dayOfWeek} className="mb-3" style={{ border: "1px solid #e0e0e0", padding: "15px", borderRadius: "8px" }}>
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="mb-0" style={{ fontWeight: "600", color: "#333" }}>
                          {timing.dayOfWeek}
                        </h6>
                        <button
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleAddPeriod(dayIndex);
                          }}
                          className="btn btn-sm"
                          style={{ 
                            backgroundColor: "#39979d", 
                            color: "white", 
                            padding: "5px 15px",
                            fontSize: "13px",
                            border: "none",
                            borderRadius: "4px"
                          }}
                        >
                          + Add Period
                        </button>
                      </div>
                      
                      {timing.periods.length === 0 ? (
                        <div style={{ textAlign: "center", color: "#999", padding: "20px 10px", fontSize: "13px" }}>
                          No hours set
                        </div>
                      ) : (
                        timing.periods.map((period, periodIndex) => (
                          <Container key={period.id} className="mb-2">
                            <Row className="align-items-center">
                              <Col md={1} className="text-center">
                                <small style={{ color: "#666" }}>Period {periodIndex + 1}</small>
                              </Col>
                              <Col md={4} className="text-center">
                                <TimePickerComponent
                                  control={control}
                                  name={`timings[${dayIndex}].periods[${periodIndex}].startLocalTime`}
                                  timings={timings}
                                  index={dayIndex}
                                  type={"startLocalTime"}
                                  errors={errors}
                                  onTimeChange={(value) =>
                                    handleTimingsChange(dayIndex, periodIndex, "startLocalTime", value)
                                  }
                                />
                              </Col>
                              <Col md={1} className="text-center">
                                <span style={{ fontWeight: "600" }}>-</span>
                              </Col>
                              <Col md={4} className="text-center">
                                <TimePickerComponent
                                  control={control}
                                  name={`timings[${dayIndex}].periods[${periodIndex}].endLocalTime`}
                                  timings={timings}
                                  index={dayIndex}
                                  type={"endLocalTime"}
                                  errors={errors}
                                  onTimeChange={(value) =>
                                    handleTimingsChange(dayIndex, periodIndex, "endLocalTime", value)
                                  }
                                />
                                {period.isNextDay && (
                                  <div style={{ fontSize: "0.75rem", color: "#ff6b6b", marginTop: "4px" }}>
                                    Closes next day
                                  </div>
                                )}
                              </Col>
                              <Col md={2} className="text-center">
                                <button
                                  type="button"
                                  onClick={() => handleRemovePeriod(dayIndex, period.id)}
                                  className="btn btn-sm btn-danger"
                                  style={{ padding: "5px 10px", fontSize: "12px" }}
                                >
                                  Remove
                                </button>
                              </Col>
                            </Row>
                          </Container>
                        ))
                      )}
                    </div>
                  ))}
                </Col>

                <Col lg={4} md={12} sm={12} className={styles.formbox}>
                  {/* File Upload */}
                  <MultipleFileUpload register={register} errors={errors} />
                </Col>
              </div>

              {/* <div className="">
              <div className="col-lg-6 col-md-12 col-sm-12">
                <p className={styles.formlabel}>Cover Image</p>
                <MultipleFileUpload />
              </div>
            </div> */}
              {/* <div className="row mt-3">
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <MultipleFileUpload />
                  </div>
                </div> */}
              {timeInvalid && (
                <span className={styles.errormsg}>
                  Please ensure all cafe timings are valid. Complete any missing{" "}
                  <strong>start time</strong> or <strong>end time</strong> for all periods.
                </span>
              )}
              <div className="d-flex justify-content-center mt-4">
                <input
                  className={styles.formbtn}
                  type="submit"
                  disabled={submiting || timeInvalid}
                  value={submiting ? "Please wait.." : "Submit"}
                />
                {/* <input
                  className={styles.resetbtn}
                  type="button"
                  value="Reset"
                  onClick={() => {
                    reset();
                  }}
                /> */}
              </div>
              <br />
              {error && (
                <h6
                  className={styles[errormsgStyle]}
                  style={{ float: "right" }}
                >
                  {error}
                </h6>
              )}
            </form>
            {/* <ToastContainer autoClose={2000} /> */}
          </div>
        </div>

        {/* Map Pin Picker Modal */}
        <MapPinPickerModal
          isOpen={showMapModal}
          onClose={() => setShowMapModal(false)}
          onConfirm={handleMapConfirm}
          initialCoordinates={
            manualCoordinates ||
            watchLocationName?.location ||
            selectedLocationData?.location
          }
          initialAddress={watchLocationName?.formatted_address || ""}
          title="Set Precise Café Location"
        />
      </div>
    );
  }
);

export default CreateCafePopup;
